import { buildFaqPageSchema } from './faqSchema';
import { buildBreadcrumbSchema } from './breadcrumbSchema';
import config from './routes.json';
import { PILOT_FAQS } from '../content/pilotFaqs';
import { REFERRAL_FAQS } from '../content/referralFaqs';
import { PAID_RESTROOMS_FAQS } from '../content/paidRestroomsFaqs';

const SITE_URL = config.siteUrl;

/** Page-level JSON-LD schemas keyed by routes.json `jsonLdSchema` values. */
export const SEO_SCHEMAS = {
  'pilot-faq': buildFaqPageSchema(PILOT_FAQS),
  'refer-faq': buildFaqPageSchema(REFERRAL_FAQS),
  'paid-restrooms-faq': [
    buildBreadcrumbSchema(SITE_URL, [
      { name: 'Home', path: '/' },
      { name: 'Paid Restrooms', path: '/paid-restrooms' },
    ]),
    buildFaqPageSchema(PAID_RESTROOMS_FAQS),
  ],
};
